import ajax from '../../lib/ajax'
export async function GetIndexUpData(payload:any) {
    let res = await ajax.get('api/services/app/Monitoring/GetIndexUpData',{params:payload},true)
    return res.data.result
}
export async function GetTenantInfo(payload:any) {
    let res = await ajax.get('api/services/app/Monitoring/GetTenantInfo',{params:payload},false)
    return res.data.result
}
export async function GetSelectListByTenantId(payload:any) {
    let res = await ajax.get('api/services/app/Monitoring/GetSelectListByTenantId',{params:payload},false)
    return res.data.result
}
export async function PatientListByMachineData(payload:any) {
    let res = await ajax.post('api/services/app/Monitoring/PatientListByMachineData',payload,true)
    return res.data.result
}
export async function PatientInMachineData(payload:any) {
    let res = await ajax.post('api/services/app/Monitoring/PatientInMachineData',payload,true)
    return res.data.result
}
export async function GetCategory(payload:any) {
    let res = await ajax.get('api/services/app/Monitoring/GetCategory',{params:payload},false)
    return res.data.result
}
export async function GetCheckListByCondition(payload:any) {
    let res = await ajax.get('api/services/app/Monitoring/GetCheckListByCondition',{params:payload},false)
    return res.data.result
}
export async function AssayYearData(payload:any) {
    let res = await ajax.post('api/services/app/Monitoring/AssayYearData',payload,true)
    return res.data.result
}
export async function PatientOutCome(payload:any) {
    let res = await ajax.post('api/services/app/Monitoring/PatientOutCome',payload,true)
    return res.data.result
}
export async function GetDialysisCaseTime(payload:any) {
    let res = await ajax.post('api/services/app/Monitoring/DialysisCaseTime',payload,true)
    return res.data.result
}
export async function PatientOutComeDetail(payload:any) {
    let res = await ajax.post('api/services/app/Monitoring/PatientOutComeDetail',payload,true)
    return res.data.result
}
export async function AssayMonthDetail(payload:any) {
    let res = await ajax.post('api/services/app/Monitoring/AssayMonthDetail',payload,true)
    return res.data.result
}
export async function AssayPercent(payload:any) {
    let res = await ajax.post('api/services/app/Monitoring/AssayPercent',payload,true)
    return res.data.result
}
export async function HDQualityInspection(payload:any) {
    let res = await ajax.post('api/services/app/Monitoring/HDQualityInspection',payload,true)
    return res.data.result
}
export async function HDQualityInspectionDetail(payload:any) {
    let res = await ajax.post('api/services/app/Monitoring/HDQualityInspectionDetail',payload,true)
    return res.data.result
}
export async function EMRPatientInfo(payload:any) {
    let res = await ajax.post('api/services/app/Monitoring/EMRPatientInfo',payload,false)
    return res.data.result
}
export async function GetPatientInfoById(payload:any) {
    let res = await ajax.get('api/services/app/Monitoring/GetPatientInfoById',{params:payload},false)
    return res.data.result
}
export async function GetAccessInfo(payload:any) {
    let res = await ajax.get('api/services/app/Monitoring/GetAccessInfo',{params:payload},false)
    return res.data.result
}
export async function GetHDInfo(payload:any) {
    let res = await ajax.get('api/services/app/Monitoring/GetHDInfo',{params:payload},false)
    return res.data.result
}
export async function GetHDDislysisDetail(payload:any) {
    let res = await ajax.get('api/services/app/Monitoring/GetHDDislysisDetail',{params:payload},false)
    return res.data.result
}
export async function GetAssayInfosByPatientId(payload:any) {
    let res = await ajax.post('api/services/app/Monitoring/GetAssayInfosByPatientId',payload,false)
    return res.data.result
}
export async function GetAssayDetailById(payload:any) {
    let res = await ajax.post('api/services/app/Monitoring/GetAssayDetailById',payload,false)
    return res.data.result
}
export async function GetSimpleItemDetail(payload:any) {
    let res = await ajax.post('api/services/app/Monitoring/GetSimpleItemDetail',payload,false)
    return res.data.result
}
export async function GetHDPrescriptInfo(payload:any) {
    let res = await ajax.get('api/services/app/Monitoring/GetHDPrescriptInfo',{params:payload},false)
    return res.data.result
}
export async function GetDialysisSuf(payload:any) {
    let res = await ajax.get('api/services/app/Monitoring/GetDialysisSuf',{params:payload},false)
    return res.data.result
}
export async function GetPACSInfo(payload:any) {
    let res = await ajax.get('api/services/app/Monitoring/GetPACSInfo',{params:payload},false)
    return res.data.result
}
export async function GetSimplePatientOutCome(payload:any) {
    let res = await ajax.get('api/services/app/Monitoring/GetSimplePatientOutCome',{params:payload},false)
    return res.data.result
}
export async function GetDiagonsisInfo(payload:any) {
    let res = await ajax.get('api/services/app/Monitoring/GetDiagonsisInfo',{params:payload},false)
    return res.data.result
}
export async function GetProPagandaInfo(payload:any) {
    let res = await ajax.get('api/services/app/Monitoring/GetProPagandaInfo',{params:payload},false)
    return res.data.result
}
export async function GetMedicationInfo(payload:any) {
    let res = await ajax.get('api/services/app/Monitoring/GetMedicationInfo',{params:payload},false)
    return res.data.result
}
export async function GetPathWayStatistics(payload:any) {
    let res = await ajax.post('api/services/app/Monitoring/GetPathWayStatistics',payload,false)
    return res.data.result
}
export async function GetPathWayOfPatientInfo(payload:any) {
    let res = await ajax.post('api/services/app/Monitoring/GetPathWayOfPatientInfo',payload,false)
    return res.data.result
}
export async function GetPathWayOutcomeStatistic(payload:any) {
    let res = await ajax.post('api/services/app/Monitoring/GetPathWayOutcomeStatistic',payload,false)
    return res.data.result
}
export async function GetPathWayOutcomePatientInfo(payload:any) {
    let res = await ajax.post('api/services/app/Monitoring/GetPathWayOutcomePatientInfo',payload,false)
    return res.data.result
}